import { createSelector } from 'reselect';

import { RootState } from 'redux/store';

export const chatSelector = (state: RootState) => state.chat;

export const getActiveChat = createSelector(
  [chatSelector],
  chatSelector => chatSelector.activeChat
);

export const getAllMessages = createSelector([chatSelector], chatSelector => chatSelector.messages);

export const isInitialChat = createSelector(
  [chatSelector],
  chatSelector => chatSelector.initialChat
);

export const getSocketUpdate = createSelector([chatSelector], chatSelector => chatSelector.socket);

export const getRespondingMessage = createSelector(
  [chatSelector],
  chatSelector => chatSelector.respondingMessage
);

export const getReplys = createSelector([chatSelector], chatSelector => chatSelector.replys);
